import React from 'react';
import { Form, Input, Icon, Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import { sanitizeFieldName } from '../../util/methods';
import DocumentList from "../AssetStockDocumentList";
import moment from "moment";
import AddPhoto from './Photos'
import ImagePreviewModal from '../ImagePreviewModal'
import EditFieldModal from './EditFieldModal'

const { TextArea } = Input;

class SubList extends React.Component {

  id = 0;

  state = {
    keys: [],
    documentData: {},
    photoPreview: { visible: false, index: 0, photos: [] },
    editModal: { visible: false, field: '', assetDetailId: '', currentValue: undefined },
  };

  editIconTitles = {
    condition: 'Condition Of Asset',
    remarks: 'Remarks',
  };

  openEditModal = (field, assetDetailId, currentValue) => {
    this.setState({ editModal: { visible: true, field, assetDetailId, currentValue } });
  };

  closeEditModal = () => {
    this.setState((prev) => ({ editModal: { ...prev.editModal, visible: false } }));
  };

  handleFieldSave = (field, value) => {
    const { editModal } = this.state;
    const payload = { _id: this.props.ast, assetDetailId: editModal.assetDetailId, [field]: value };
    if (this.props.onUpdateAssetDetailField) {
      this.props.onUpdateAssetDetailField(payload);
    }
    this.closeEditModal();
  };

  getConditionOptions = () => {
    const { item } = this.props;
    return (item && item.schema && item.schema.condition
      && item.schema.condition.data && item.schema.condition.data.data) || [];
  };

  confirmRemove = (assetDetailId, assetCode) => {
    if (!assetDetailId) return;
    Modal.confirm({
      title: 'Remove this record?',
      content: `Are you sure you want to remove ${assetCode || 'this asset detail'} from the report?`,
      okText: 'Remove',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: () => {
        if (this.props.onRemoveAssetDetail) {
          this.props.onRemoveAssetDetail({ _id: this.props.ast, assetDetailId });
        }
      },
    });
  };

  // Editable / removable only on the VIEW page while the report is not submitted.
  canEdit = () => this.props.title === 'VIEW' && this.props.notSubmitted;

  renderEditIcon = (field, assetDetailId, currentValue) => {
    if (!this.canEdit() || !assetDetailId) return null;
    return (
      <Icon
        type='edit'
        title={`Edit ${this.editIconTitles[field] || field}`}
        onClick={() => this.openEditModal(field, assetDetailId, currentValue)}
        style={{ marginLeft: 8, color: '#1890ff', cursor: 'pointer' }}
      />
    );
  };

  componentDidMount() {
    const { data = [{}] } = this.props;
    this.setState({
      keys: data,
    });
  }

  clearDocumentData() {
    this.setState({ documentData: {} });
  }

  getDocumentData = (index, data) => {
    this.props.form.setFieldsValue({ [`assetDetails[${index}][fileData]`]: data });
    this.setState({ documentData: data });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        keys: nextProps.data,
      });
    }
  }

  remove = index => {
    const { keys } = this.state;
    const { form, item } = this.props;
    const { field } = item;
    if (keys.length === 1) {
      return;
    }
    const val = form.getFieldValue(field);
    val.splice(index, 1);

    keys.splice(index, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((item, index) => {
        form.setFieldsValue({
          [`${field}[${i}][${item}]`]: val[i][item],
        });
      });
    }
    this.setState({
      keys: keys,
    });
  };

  add = () => {
    const { item: { field } } = this.props;
    const { keys } = this.state;
    keys.push(`${field}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  openAttachmentInNewTab = async (event, url) => {
    event.preventDefault();
    if (!url) {
      return;
    }

    const previewWindow = window.open('', '_blank', 'noopener,noreferrer');
    if (!previewWindow) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    previewWindow.document.write('Loading attachment preview...');

    try {
      const response = await fetch(url, { credentials: 'include' });
      if (!response.ok) {
        throw new Error(`Unable to fetch attachment. Status: ${response.status}`);
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      previewWindow.location.href = blobUrl;

      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch (error) {
      previewWindow.location.href = url;
    }
  };

  openPhotoPreview = (photos, index) => {
    const list = (photos || [])
      .filter((p) => p && p.url)
      .map((p, i) => ({ url: p.url, name: p.name || `Attachment ${i + 1}` }));
    this.setState({ photoPreview: { visible: true, index, photos: list } });
  };

  closePhotoPreview = () => {
    this.setState((prev) => ({ photoPreview: { ...prev.photoPreview, visible: false } }));
  };

  render() {
    const {
      form,
      item,
      data = [],
      openedBy,
      resource,
      title,
      latitude,
      longitude,
      superMaster,
      subMaster,
      subDocumentFilters
    } = this.props;
    const { field } = item;
    const { getFieldDecorator, setFieldsValue } = form;
    const { keys } = this.state;

    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '10px',
      borderRadius: '9px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      wordBreak: 'break-all',
    };

    const formItems = keys.map((k, index) => (

      <div key={index} style={style}>
        <div className='assets-code-section'>
          <div className={'asset-details-location-stamp'}>
            <div className={'asset-details-section'}>
              <span
                className={'asset-details-heading'}>{sanitizeFieldName(item.schema['assetCode'].options.label ? item.schema['assetCode'].options.label : item.schema['assetCode'].field)}</span>:&nbsp; {data && data[index] ? data[index]['assetCode'] : ''}
            </div>

            {
              (title === 'VIEW') && <div className={'asset-details-section'}>
                <span className={'asset-details-heading'}>Entry Type</span>:&nbsp; {
                  (data && data[index] && !!data[index]['manual']) ? 'Manual' : 'QR Code'}
              </div>
            }
            {
              (title === 'VIEW') && <div className={'asset-details-section'}>
                <span className={'asset-details-heading'}>Time</span>:&nbsp; {
                  (data && data[index] && data[index]['time']) ? moment(data[index]['time']).format('MM-DD-YYYY hh:mm a') : ''}
              </div>
            }
          </div>

          <div className={'asset-details-section-two-1'}>
            <span
              className={'asset-details-heading'}>{sanitizeFieldName(item.schema['isQrMismatched'].options.label ? item.schema['isQrMismatched'].options.label : item.schema['isQrMismatched'].field)}</span>:&nbsp;
            {(data && data[index] && !!data[index]['isQrMismatched']) ? <span style={{ color: 'tomato' }}>Yes</span> :
              <span style={{ color: 'Green' }}>No</span>}
          </div>

          <div className={'asset-details-location-stamp'}>
            <div className={'asset-details-section'}>
              <span className={'asset-details-heading'}>Tag Id :</span>&nbsp;
              {(data && data[index] && data[index]['link_record'])
                ? typeof data[index]['link_record'] === 'string'
                  ? data[index]['link_record'] : data[index]['link_record']['_id'] ? data[index]['link_record']['code'] : data[index]['link_record'] : data && data[index] && data[index]['link_record']}
            </div>

            {
              (title === 'VIEW') && <div className={'asset-details-section'}>
                <span className={'asset-details-heading'}>QR</span>:&nbsp; {
                  (data && data[index] && data[index]['link_record'] && data[index]['link_record']['scannerData']
                    && data[index]['link_record']['scannerData'].length && data[index]['link_record']['scannerData'][0]['id'])}
              </div>
            }

            {
              (title === 'VIEW') && <div className={'asset-details-section'}>
                <span className={'asset-details-heading'}>Tag Type</span>:&nbsp; {
                  (data && data[index] && data[index]['link_record'] && data[index]['link_record']['scannerData']
                    && data[index]['link_record']['scannerData'].length && data[index]['link_record']['scannerData'][0]['tag_type']
                    && data[index]['link_record']['scannerData'][0]['tag_type']['name'])}
              </div>
            }

            {
              (title === 'VIEW') && <div className={'asset-details-section'}>
                {
                  ((data && data[index] && data[index]['link_record'] && data[index]['link_record']['photos']) || [])
                    .map((p, ix) => <a style={{ display: 'block' }} key={p.url} href={p.url}
                      target='_blank' rel='noopener noreferrer' onClick={(event) => this.openAttachmentInNewTab(event, p.url)}>{`Tag Photo -${ix + 1}`}</a>)}
              </div>
            }
          </div>

          <div className={'asset-details-section-two'}>
            <span
              className={'asset-details-heading'}>{sanitizeFieldName(item.schema['condition'].options.label ? item.schema['condition'].options.label : item.schema['condition'].field)}</span>:&nbsp;
            {data && data[index] ? data[index]['condition'] && (data[index]['condition'].name || data[index]['condition']) : ''}
            {this.renderEditIcon('condition', data && data[index] && data[index]['_id'], (data && data[index] && data[index]['condition'] && data[index]['condition']._id) ? data[index]['condition']._id : undefined)}
          </div>

          <div className={'asset-details-section-two'}>
            <span
              className={'asset-details-heading'}>{sanitizeFieldName(item.schema['remarks'].options.label ? item.schema['remarks'].options.label : item.schema['remarks'].field)}</span>:&nbsp;
            {data && data[index] ? data[index]['remarks'] && data[index]['remarks'] : ''}
            {this.renderEditIcon('remarks', data && data[index] && data[index]['_id'], data && data[index] ? data[index]['remarks'] : undefined)}
          </div>

          <div className={'asset-details-location-stamp'}>
            <div className={'asset-details-section'}>
              <span className={'asset-details-heading'}>Entered By</span>:&nbsp;
              {data && data[index] ? ((data[index]['user'] && data[index]['user'] && data[index]['user'].name) || (openedBy && openedBy.name)) : ''}
            </div>
            <div className={'asset-details-section'}>
              <span
                className={'asset-details-heading'}>{sanitizeFieldName(item.schema['latitude'].options.label ? item.schema['latitude'].options.label : item.schema['latitude'].field)}</span>:&nbsp;
              {data && data[index] ? ((data[index]['latitude'] && data[index]['latitude']) || (latitude) || 0).toFixed(6) : ''}
            </div>
            <div className={'asset-details-section'}>
              <span
                className={'asset-details-heading'}>{sanitizeFieldName(item.schema['longitude'].options.label ? item.schema['longitude'].options.label : item.schema['longitude'].field)}</span>:&nbsp;
              {data && data[index] ? ((data[index]['longitude'] && data[index]['longitude']) || (longitude) || 0).toFixed(6) : ''}
            </div>
          </div>

          <Form.Item style={{ display: 'none' }}>
            {getFieldDecorator(`${field}[${index}][fileData]`, {
              rules: false, message: '',
              initialValue: '',
            })(<Input style={{ display: 'none' }} />)
            }
          </Form.Item>

          {this.canEdit() && data && data[index] && data[index]['_id'] && (
            <div className={'asset-details-section'} style={{ marginTop: 8 }}>
              <Button type='danger' size='small' icon='delete'
                onClick={() => this.confirmRemove(data[index]['_id'], data[index]['assetCode'])}>
                Remove
              </Button>
            </div>
          )}
        </div>
        {
          (data && data[index] && data[index].photos) ? <div className='document-upload'>
            <div className={'asset-details-heading-photo'}>Photos</div>
            {
              data[index].photos && data[index].photos.length ? (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {data[index].photos.map((photo, photoIx) => (
                    <img
                      key={photo.url}
                      src={photo.url}
                      alt={photo.name || `Attachment ${photoIx + 1}`}
                      title={photo.name || `Attachment ${photoIx + 1}`}
                      onClick={() => this.openPhotoPreview(data[index].photos, photoIx)}
                      style={{
                        width: 56,
                        height: 56,
                        objectFit: 'cover',
                        borderRadius: 4,
                        border: '1px solid #d9d9d9',
                        cursor: 'pointer',
                      }}
                    />
                  ))}
                </div>
              ) : 'No Attachments'
            }
            <AddPhoto
              isApproved={this.props.isApproved}
              key={item}
              data={{ ...data[index], _id: this.props.ast }} onUpload={this.props.onSubmitWithDocument} />
          </div> : <></>
          // <DocumentList match={this.props.match} history={this.props.history} documentData={this.state.documentData}
          //   key={index} item={item.schema['photos']} form={form} data={data[index] && data[index].photos}
          //   getDocumentData={this.getDocumentData.bind(this, index)} />

        }
      </div>
    ));

    return (
      <div className='stock-taking-sublist'>
        {formItems}
        <br />
        <ImagePreviewModal
          visible={this.state.photoPreview.visible}
          photos={this.state.photoPreview.photos}
          initialIndex={this.state.photoPreview.index}
          onClose={this.closePhotoPreview}
        />
        <EditFieldModal
          visible={this.state.editModal.visible}
          field={this.state.editModal.field}
          title={this.editIconTitles[this.state.editModal.field] || 'Edit'}
          currentValue={this.state.editModal.currentValue}
          conditionOptions={this.getConditionOptions()}
          onSave={this.handleFieldSave}
          onCancel={this.closeEditModal}
        />
      </div>
    );
  }
}

export default SubList;
SubList.defaultProps = {};

SubList.propTypes = {
  item: PropTypes.object,
};
